export var SceneTaskTypeNum;
(function (SceneTaskTypeNum) {
    SceneTaskTypeNum[SceneTaskTypeNum["Unknown"] = -1] = "Unknown";
    SceneTaskTypeNum[SceneTaskTypeNum["DeviceTask"] = 0] = "DeviceTask";
    SceneTaskTypeNum[SceneTaskTypeNum["DelayTask"] = 1] = "DelayTask";
    SceneTaskTypeNum[SceneTaskTypeNum["NotifyTask"] = 2] = "NotifyTask";
    SceneTaskTypeNum[SceneTaskTypeNum["LockExecution"] = 3] = "LockExecution";
})(SceneTaskTypeNum || (SceneTaskTypeNum = {}));
export var SceneTaskType;
(function (SceneTaskType) {
    SceneTaskType["Unknown"] = "Unknown";
    SceneTaskType["DeviceTask"] = "DeviceTask";
    SceneTaskType["DelayTask"] = "DelayTask";
    SceneTaskType["NotifyTask"] = "NotifyTask";
    SceneTaskType["LockExecution"] = "LockExecution";
})(SceneTaskType || (SceneTaskType = {}));
export var HandledType;
(function (HandledType) {
    HandledType[HandledType["Unknown"] = 0] = "Unknown";
    HandledType[HandledType["Second"] = 1] = "Second";
    HandledType[HandledType["Minute"] = 2] = "Minute";
    HandledType[HandledType["Hour"] = 3] = "Hour";
    HandledType[HandledType["Day"] = 4] = "Day";
    HandledType[HandledType["DayOfWeek"] = 5] = "DayOfWeek";
    HandledType[HandledType["Month"] = 6] = "Month";
    HandledType[HandledType["Year"] = 7] = "Year";
    HandledType[HandledType["Date"] = 8] = "Date";
    HandledType[HandledType["Time"] = 9] = "Time";
    //AstronomicalClock = "AstronomicalClock", //10
    HandledType[HandledType["WeatherType"] = 11] = "WeatherType";
    HandledType[HandledType["CompareNumbers"] = 12] = "CompareNumbers";
    HandledType[HandledType["CompareBooleans"] = 13] = "CompareBooleans";
    HandledType[HandledType["DeviceState"] = 14] = "DeviceState";
    HandledType[HandledType["Timer"] = 15] = "Timer";
    HandledType[HandledType["Temperature"] = 17] = "Temperature";
    HandledType[HandledType["DaysOfWeek"] = 18] = "DaysOfWeek";
    HandledType[HandledType["AstronomicalClockWithOffset"] = 19] = "AstronomicalClockWithOffset";
    HandledType[HandledType["SceneExecuted"] = 20] = "SceneExecuted";
})(HandledType || (HandledType = {}));
export var ConditionsTypes;
(function (ConditionsTypes) {
    ConditionsTypes[ConditionsTypes["Unknown"] = 0] = "Unknown";
    ConditionsTypes[ConditionsTypes["Equal"] = 1] = "Equal";
    ConditionsTypes[ConditionsTypes["NotEqueal"] = 2] = "NotEqueal";
    ConditionsTypes[ConditionsTypes["BiggerThan"] = 3] = "BiggerThan";
    ConditionsTypes[ConditionsTypes["SmallerThan"] = 4] = "SmallerThan";
    ConditionsTypes[ConditionsTypes["BiggerThanOrEqual"] = 5] = "BiggerThanOrEqual";
    ConditionsTypes[ConditionsTypes["SmallerThanOrEqual"] = 6] = "SmallerThanOrEqual";
    ConditionsTypes[ConditionsTypes["OneOfBothIsTrue"] = 7] = "OneOfBothIsTrue";
    ConditionsTypes[ConditionsTypes["BothAreTrue"] = 8] = "BothAreTrue";
})(ConditionsTypes || (ConditionsTypes = {}));
export var DeviceStateType;
(function (DeviceStateType) {
    DeviceStateType[DeviceStateType["Unknown"] = 0] = "Unknown";
    DeviceStateType[DeviceStateType["BatteryState"] = 1] = "BatteryState";
    DeviceStateType[DeviceStateType["BinarySensor"] = 2] = "BinarySensor";
    DeviceStateType[DeviceStateType["BlindPosition"] = 3] = "BlindPosition";
    DeviceStateType[DeviceStateType["Brightness"] = 4] = "Brightness";
    DeviceStateType[DeviceStateType["ButtonState"] = 5] = "ButtonState";
    DeviceStateType[DeviceStateType["ChannelOnOff"] = 6] = "ChannelOnOff";
    DeviceStateType[DeviceStateType["DoorBell"] = 7] = "DoorBell";
    DeviceStateType[DeviceStateType["Energy"] = 8] = "Energy";
    DeviceStateType[DeviceStateType["FloodSensor"] = 9] = "FloodSensor";
    DeviceStateType[DeviceStateType["GatePosition"] = 10] = "GatePosition";
    DeviceStateType[DeviceStateType["HeatSensor"] = 11] = "HeatSensor";
    DeviceStateType[DeviceStateType["LightBrightness"] = 12] = "LightBrightness";
    DeviceStateType[DeviceStateType["LightColor"] = 13] = "LightColor";
    DeviceStateType[DeviceStateType["LightTemperature"] = 14] = "LightTemperature";
    DeviceStateType[DeviceStateType["MeasuredCurrent"] = 15] = "MeasuredCurrent";
    DeviceStateType[DeviceStateType["MeasuredPower"] = 16] = "MeasuredPower";
    DeviceStateType[DeviceStateType["MeasuredVoltage"] = 17] = "MeasuredVoltage";
    DeviceStateType[DeviceStateType["ReedState"] = 18] = "ReedState";
    DeviceStateType[DeviceStateType["SmokeSensor"] = 19] = "SmokeSensor";
    DeviceStateType[DeviceStateType["Temperature"] = 20] = "Temperature";
    DeviceStateType[DeviceStateType["BlindsControlButton"] = 21] = "BlindsControlButton";
    DeviceStateType[DeviceStateType["Movement"] = 22] = "Movement";
    DeviceStateType[DeviceStateType["WindSpeed"] = 24] = "WindSpeed";
    DeviceStateType[DeviceStateType["Humidity"] = 25] = "Humidity";
    DeviceStateType[DeviceStateType["AirPressure"] = 26] = "AirPressure";
    DeviceStateType[DeviceStateType["WindThreshold"] = 31] = "WindThreshold";
    DeviceStateType[DeviceStateType["FacadeControlButton"] = 36] = "FacadeControlButton";
})(DeviceStateType || (DeviceStateType = {}));
export var ArgumentTypeNum;
(function (ArgumentTypeNum) {
    ArgumentTypeNum[ArgumentTypeNum["Null"] = 0] = "Null";
    ArgumentTypeNum[ArgumentTypeNum["Condition"] = 1] = "Condition";
    ArgumentTypeNum[ArgumentTypeNum["ConditionGroup"] = 2] = "ConditionGroup";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsInt"] = 3] = "ArgumentAsInt";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsTimeSpan"] = 4] = "ArgumentAsTimeSpan";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsBoolean"] = 5] = "ArgumentAsBoolean";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsTimeout"] = 6] = "ArgumentAsTimeout";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsDayOfWeek"] = 7] = "ArgumentAsDayOfWeek";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsDaysOfWeek"] = 8] = "ArgumentAsDaysOfWeek";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsAstronomicalClock"] = 9] = "ArgumentAsAstronomicalClock";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsTime"] = 10] = "ArgumentAsTime";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsDeviceState"] = 11] = "ArgumentAsDeviceState";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsNumber"] = 12] = "ArgumentAsNumber";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsAstronomicalClockWithOffset"] = 13] = "ArgumentAsAstronomicalClockWithOffset";
    ArgumentTypeNum[ArgumentTypeNum["ArgumentAsConditionInfo"] = 14] = "ArgumentAsConditionInfo";
})(ArgumentTypeNum || (ArgumentTypeNum = {}));
export var ArgumentType;
(function (ArgumentType) {
    ArgumentType["Null"] = "Null";
    ArgumentType["Condition"] = "Condition";
    ArgumentType["ConditionGroup"] = "ConditionGroup";
    ArgumentType["ArgumentAsInt"] = "ArgumentAsInt";
    ArgumentType["ArgumentAsTimeSpan"] = "ArgumentAsTimeSpan";
    ArgumentType["ArgumentAsBoolean"] = "ArgumentAsBoolean";
    ArgumentType["ArgumentAsTimeout"] = "ArgumentAsTimeout";
    ArgumentType["ArgumentAsDayOfWeek"] = "ArgumentAsDayOfWeek";
    ArgumentType["ArgumentAsDaysOfWeek"] = "ArgumentAsDaysOfWeek";
    ArgumentType["ArgumentAsAstronomicalClock"] = "ArgumentAsAstronomicalClock";
    ArgumentType["ArgumentAsTime"] = "ArgumentAsTime";
    ArgumentType["ArgumentAsDeviceState"] = "ArgumentAsDeviceState";
    ArgumentType["ArgumentAsNumber"] = "ArgumentAsNumber";
    ArgumentType["ArgumentAsAstronomicalClockWithOffset"] = "ArgumentAsAstronomicalClockWithOffset";
    ArgumentType["ArgumentAsConditionInfo"] = "ArgumentAsConditionInfo";
})(ArgumentType || (ArgumentType = {}));
export var SupportedTaskTypes;
(function (SupportedTaskTypes) {
    SupportedTaskTypes["DeviceTask"] = "DeviceTask";
    SupportedTaskTypes["DelayTask"] = "DelayTask";
    SupportedTaskTypes["LockExecutionTask"] = "LockExecutionTask";
    SupportedTaskTypes["NotifyTaskAppNotify"] = "NotifyTaskAppNotify";
    SupportedTaskTypes["NotifyTaskEmailNotify"] = "NotifyTaskEmailNotify";
})(SupportedTaskTypes || (SupportedTaskTypes = {}));
export class ScenesUsedIn {
    constructor() {
        this.Guid = "";
        this.SceneName = "";
        this.ConditionsAsSceneExecuted = [];
        this.ConditionsAsSceneLock = [];
    }
}
//Errors
export class UnsupportedScenesDeviceState extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        this.name = "UnsupportedScenesDeviceState";
    }
}
//# sourceMappingURL=Scenes.js.map